import cn from 'classnames'
import { Typography } from '../Typography'
import { Button, BUTTON_TYPES } from '../Button'
import { ReactComponent as WarningIcon } from 'assets/svg/WarningIcon.svg'
import { BannerProps } from './types'
import './banner.warning.scss'

export const Warning = ({
  text,
  className,
  button,
  subtext,
  children
}: BannerProps) => (
  <div
    className={cn(
      'banner banner--warning row gap-12 align-center space-between',
      className
    )}
  >
    <div className="row gap-12 align-center align-start">
      <WarningIcon />
      <div className="column">
        <Typography.Body1>{text}</Typography.Body1>
        {subtext && (
          <Typography.Caption className="mt-8">{subtext}</Typography.Caption>
        )}
        {children}
      </div>
    </div>
    {!!button?.length && (
      <div className="row gap-8 align-center nowrap">
        {button.map(
          ({
            buttonType,
            onButtonClick,
            buttonIcon,
            buttonText,
            underlineInfo
          }) => (
            <div className="column gap-8" key={buttonText}>
              <Button
                type={buttonType ?? BUTTON_TYPES.GHOST}
                onClick={onButtonClick}
                upperCase
                icon={buttonIcon}
              >
                {buttonText}
              </Button>
              {underlineInfo && (
                <div className="underline">{underlineInfo}</div>
              )}
            </div>
          )
        )}
      </div>
    )}
  </div>
)
